var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageLoader',{attrs:{"storage":_vm.appLoading}}),(_vm.ServerError)?_c('ServerError'):_vm._e(),_c('v-layout',{attrs:{"wrap":"","justify-center":"","py-md-0":""}},[_c('v-flex',[_c('WelcomePage')],1),_c('v-flex',[_c('About')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }